import { apiSlice } from "./apiSlice";
import { setCredentials, logOut } from "../slices/authSlice";

export const authApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		login: builder.mutation({
			query: (credentials) => ({
				url: "/Auth/login",
				method: "POST",
				body: credentials,
			}),
			async onQueryStarted(_, { dispatch, queryFulfilled }) {
				try {
					const { data } = await queryFulfilled;
					dispatch(setCredentials(data));
				} catch (error) {
					// Error is handled by the component
				}
			},
		}),
	}),
});

export const { useLoginMutation } = authApiSlice;
